/**
 * Typed accessor for Vite env variables.
 *
 * All runtime config that differs between environments lives here.
 * Components and services import `env` — they never read import.meta.env directly.
 */

const rawApiBaseUrl = import.meta.env.VITE_API_BASE_URL;

if (!rawApiBaseUrl) {
  // Warn at startup (once, at module load). This is intentional: the app can
  // still render with an empty base URL so developers see the UI in Storybook
  // or local mocks without a real backend.
  console.warn(
    '[iTow] VITE_API_BASE_URL is not set. API calls will fail until it is ' +
      'configured in .env.local (development) or the deployment environment.'
  );
}

const rawFirebaseProjectId = import.meta.env.VITE_FIREBASE_PROJECT_ID;

if (!rawFirebaseProjectId) {
  // Same non-fatal pattern as apiBaseUrl — app mounts; Firestore hooks return idle state.
  console.warn(
    '[iTow] VITE_FIREBASE_PROJECT_ID is not set. Firestore real-time listeners ' +
      'will be disabled until Firebase env vars are configured.'
  );
}

export const env = {
  /** Base URL for the .NET API (e.g. https://itow-api.azurewebsites.net). */
  apiBaseUrl: rawApiBaseUrl ?? '',

  /** Firebase project configuration. Values come from the Firebase console. */
  firebase: {
    apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
    authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
    projectId: rawFirebaseProjectId,
    storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
    appId: import.meta.env.VITE_FIREBASE_APP_ID,
  },
} as const;
